import { ref } from 'vue'

export const mobileShellEnabled = import.meta.env.VITE_MOBILE_SHELL !== 'false'
export const compact = ref(typeof window !== 'undefined' && window.innerWidth < 768)
export const online = ref(navigator.onLine)
export const visible = ref(document.visibilityState === 'visible')
export const pendingWrites = ref(0)
export const frozen = ref(false)
export const draftCount = ref(0)
// F13.4 outbox: actions waiting to sync, actions the server rejected, sync running.
export const queuedCount = ref(0)
export const reviewCount = ref(0)
export const syncing = ref(false)
export const storageError = ref('')
export const draftRevision = ref(0)
const flushers = new Set()
export const registerDraftFlusher = fn => { flushers.add(fn); return () => flushers.delete(fn) }
export async function flushDrafts() { await Promise.all([...flushers].map(fn => fn())) }
export function localDay(d = new Date()) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` }
window.addEventListener('resize', () => { compact.value = window.innerWidth < 768 })
window.addEventListener('online', () => { online.value = true })
window.addEventListener('offline', () => { online.value = false })
document.addEventListener('visibilitychange', () => {
  visible.value = document.visibilityState === 'visible'
  if (!visible.value) flushDrafts().catch(() => { storageError.value = 'Không lưu được bản nháp. Vui lòng giữ màn hình và thử lại.' })
})


// A different account in another tab must never keep the old account's form visible.
window.addEventListener('storage', event => {
  if (event.key !== 'user') return
  const identity = value => { try { const u=JSON.parse(value);return u?.id+':'+u?.farm_id } catch { return null } }
  if(identity(event.oldValue)!==identity(event.newValue))window.location.reload()
})
